import SearchIcon from '@mui/icons-material/Search';
import { Stack, InputBase, Grid, Box } from '@mui/material';
import { isEmpty } from 'lodash-es';
import { useState, useEffect } from 'react';
import { useForm, FormProvider } from 'react-hook-form';
import { useNavigate } from 'react-router-dom';
import { closeWorkAssignments, ITeam } from 'wisestep-api';
import { WsCheckboxList, WsButton, WsIconPublish, WsColors } from 'wisestep-base';

import WsCheckBox from '../../../../components/WsCheckBox/WsCheckBox';
import { failed, success, warning } from '../../../../utils/NotificationMessages';
import { useNotificationStore } from '../../../../utils/NotificationStore';
import { assignments } from '../../helper';
import { IWorkAssignments, StyledFooter } from '../types';

export interface IAssignedTeamsList {
  workAssignments: IWorkAssignments;
  jobId: string;
  refreshJob(): void;
}
const AssignedTeamsList = ({ workAssignments, jobId, refreshJob }: IAssignedTeamsList) => {
  const methods = useForm();
  methods.register('selectAll');
  const { watch, setValue } = methods;
  assignments.jobDTOList = [jobId];
  const setNotification = useNotificationStore((state) => state.setNotification);
  const [workAssignmentsOfTeams, setWorkAssignmentsOfTeams] = useState<ITeam[]>(
    workAssignments.teams
  );
  const navigate = useNavigate();

  useEffect(() => {
    setWorkAssignmentsOfTeams(workAssignments.teams);
  }, [workAssignments.teams]);

  const teamsOptions: {
    [key: string]: string;
  } = {};

  workAssignmentsOfTeams.forEach((team) => {
    if (team.id && team.name) {
      teamsOptions[team.id] = team.name;
    }
  });

  const selectedTeamIds = watch('teamsList');

  const onTeamsInput = (event) => {
    if (!isEmpty(event.target.value)) {
      const filteredRows =
        workAssignments.teams?.filter((row) => {
          return row?.name?.toLowerCase().includes(event.target.value.toLowerCase());
        }) ?? [];
      setWorkAssignmentsOfTeams(filteredRows);
    } else {
      setWorkAssignmentsOfTeams(workAssignments.teams);
    }
  };
  const unAssign = async () => {
    assignments.teamDTOList = selectedTeamIds;
    if (assignments.teamDTOList && assignments.teamDTOList.length > 0) {
      try {
        await closeWorkAssignments(assignments);
        setNotification(success(`Job Un-assigned Successfully.`));
        refreshJob();
        setValue('teamsList', null);
      } catch {
        setNotification(failed(`Failed to Unassign the Job. Please try again.`));
      }
    } else {
      setNotification(warning('Please select minimum one team to assign the job!'));
    }
  };
  const handleSelectEvents = (checked: boolean) =>
    checked ? setValue('teamsList', Object.keys(teamsOptions)) : setValue('teamsList', []);

  const navigateToPublish = () => navigate(`/jobs/${jobId}/publish`);

  return (
    <Box>
      <FormProvider {...methods}>
        <Stack direction="row" spacing={1} alignItems={'center'}>
          <SearchIcon />
          <InputBase placeholder="search" onChange={onTeamsInput} fullWidth />
        </Stack>
        <Stack spacing={1}>
          <WsCheckBox
            name="selectAll"
            label="Select All Teams"
            bold={true}
            onClick={handleSelectEvents}
          />
          <WsCheckboxList name="teamsList" options={teamsOptions} />
        </Stack>
        <StyledFooter>
          <Grid container item justifyContent="space-between" py={1}>
            <WsButton variant="text" size="large">
              {`${selectedTeamIds?.length ?? 0} Selected`}
            </WsButton>
            <WsButton variant="outlined" id="unassign" size="large" onClick={unAssign}>
              Unassign
            </WsButton>
            <WsButton
              id="publish"
              startIcon={<WsIconPublish color={WsColors.White} />}
              size="large"
              onClick={navigateToPublish}
            >
              Publish
            </WsButton>
          </Grid>
        </StyledFooter>
      </FormProvider>
    </Box>
  );
};

export default AssignedTeamsList;
